// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"z4-z","dimensionLabel":"A4-z","styleChooserControlWrapper":"B4-z","styleChooserControl":"C4-z","disabled":"D4-z","giftCard":"E4-z","styleChooserText":"F4-z"};